import { updateList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function UpdateLog() {
  return (
    <section id="updates" className="w-full scroll-mt-20 border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="线路更新日志"
          title="地址变动有记录，入口变化随时可查"
          desc="每一次域名更换、线路新增或维护都会在这里留下记录，方便你确认自己使用的是不是最新地址。"
        />

        <ol className="mt-10 flex flex-col">
          {updateList.map((item, index) => (
            <li key={item.date} className="relative flex gap-5 pb-8 last:pb-0">
              <div className="flex flex-col items-center">
                <span className="flex h-3.5 w-3.5 items-center justify-center rounded-full bg-accent-500 ring-4 ring-accent-100"></span>
                {index !== updateList.length - 1 ? (
                  <span className="mt-1 w-px flex-1 bg-background-300"></span>
                ) : null}
              </div>
              <div className="min-w-0 flex-1 -mt-1">
                <div className="flex flex-wrap items-center gap-2">
                  <time className="font-label text-sm text-foreground-500">{item.date}</time>
                  <span className="rounded-full border border-secondary-300 bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {item.tag}
                  </span>
                </div>
                <h3 className="mt-1.5 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}